export default __webpack_public_path__ + "static/media/dt_glass.30bfbef0.mp3";